/**
 * LessonLink - 授業管理システム
 * メインエントリポイント
 */
import { Amplify } from 'aws-amplify';
import outputs from '../amplify_outputs.json';
import { showPage, pages } from './utils';
import { initAuth, checkAuthState } from './auth';
import { initSchedule, loadLessons } from './schedule';
import { initContact, loadContactList } from './contact';
import { initSettings, ensureUserRecord, updateHeaderDisplayName, loadSettings, clearUserState, getCurrentUserRole } from './settings';
import { initUsers, loadUsers } from './users';
import { initSummaryTraining } from './summaryTraining';
import { isInstructor } from './utils';

Amplify.configure(outputs);

// ログイン成功時の共通処理
const onLoginSuccess = async () => {
  try {
    await ensureUserRecord();
    updateHeaderDisplayName();
    // ロールに応じてユーザー管理タブを表示
    const role = getCurrentUserRole();
    const navUsersItem = document.getElementById('nav-users-item');
    if (navUsersItem) {
      navUsersItem.style.display = isInstructor(role) ? '' : 'none';
    }
  } catch (error) {
    console.error('User record error:', error);
  }
  loadLessons();
};

// ナビゲーション
const mainNav = document.getElementById('main-nav') as HTMLElement;
mainNav.addEventListener('click', (e) => {
  const target = e.target as HTMLElement;
  const link = target.closest('[data-page]') as HTMLElement;
  if (!link) return;

  e.preventDefault();
  const pageName = link.dataset.page;

  switch (pageName) {
    case 'schedule':
      showPage(pages.pageSchedule);
      break;
    case 'contact':
      showPage(pages.pageContact);
      loadContactList();
      break;
    case 'settings':
      showPage(pages.pageSettings);
      loadSettings();
      break;
    case 'users':
      showPage(pages.pageUsers);
      loadUsers();
      break;
    case 'summary':
      showPage(pages.pageSummary);
      break;
  }
});

// 初期化
initAuth(onLoginSuccess, clearUserState);
initSchedule();
initContact();
initSettings();
initUsers();
initSummaryTraining();
checkAuthState(onLoginSuccess);
